export default "__VITE_ASSET__IHYhNLvJ__"